import { render, staticRenderFns } from "./CourseAdjustmentStatistics.vue?vue&type=template&id=b5f1d8e2&scoped=true"
import script from "./CourseAdjustmentStatistics.vue?vue&type=script&lang=js"
export * from "./CourseAdjustmentStatistics.vue?vue&type=script&lang=js"
import style0 from "./CourseAdjustmentStatistics.vue?vue&type=style&index=0&id=b5f1d8e2&prod&scoped=true&lang=css"
import style1 from "./CourseAdjustmentStatistics.vue?vue&type=style&index=1&id=b5f1d8e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f1d8e2",
  null
  
)

export default component.exports